import React from 'react';

const Span = ({ value }) => <span>{value}</span>;

export default Span;
